import 'css-chunk:src/applications/SocialPostApp/components/BrandAuth.scss';export default {
  "titleStyle": "_titleStyle_sfhn5_1",
  "imgLogo": "_imgLogo_sfhn5_7"
};